export const ADD_STAGE = 'ADD_STAGE';
export const DELETE_STAGE = 'DELETE_STAGE';
export const EDIT_STAGE = 'EDIT_STAGE';
export const LOAD_STAGE = 'LOAD_STAGE';


export function addStage(data) {
  return {
    type: ADD_STAGE,
    payload: data,
  }
}

export function deleteStage(data) {
  return {
    type: DELETE_STAGE,
    payload: data,
  }
}

export function editStage(data) {
  return {
    type: EDIT_STAGE,
    payload: data,
  }
}

export function loadStage(data) {
  return {
    type: LOAD_STAGE,
    payload: data,
  }
}


// WEBPACK FOOTER //
// ./src/actions/boardStage/index.js